export const DEFAULT_NO_DATA_TEXT = 'No Data';
